import React from 'react';
import { StudyEcgs, StudyComparePopUp, PatientStatistic } from './components';
import { useAppSelector, useEffect, useAppDispatch } from 'hooks';
import { ViewModeChanger, ScreenTitle } from 'components';
import { useStudyWaveforms } from './hooks/hooks';
import { ViewMode } from 'types/enums';
import { studyActions } from 'utils/store';

export const Study = () => {
  const { updateStudyWaveforms, onViewModeChange, onFacilityChange } = useStudyWaveforms();
  const { studyViewMode } = useAppSelector((state) => state.study);
  const dispatch = useAppDispatch();
  const isAdminViewMode = studyViewMode === ViewMode.ADMIN;

  useEffect(() => {
    dispatch(studyActions.getStudyStatistic());
    updateStudyWaveforms();
  }, [updateStudyWaveforms, dispatch]);

  return (
    <>
      <ScreenTitle title='Study ECGs' />
      <ViewModeChanger
        onModeChange={onViewModeChange}
        onMonitoringFacilityChange={onFacilityChange}
        viewMode={studyViewMode}
      />
      <PatientStatistic />
      <StudyEcgs />
      <StudyComparePopUp onClose={updateStudyWaveforms} />
    </>
  );
};
